import React from "react"; // Must import React if you use JSX
import Admin from './pages/Admin';
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import PostDetail from './pages/PostDetail';
import Posts from './pages/Posts';


const routes = [
  {
    name: "Home",
    path: "/",
    exact: true,
    main: (match) => <HomePage match={match} /> // match is used to get params on URL
  },
  {
    name: "Apllication",
    path: "/applications",
    exact: true,
    main: ({ match, location }) => <Posts match={match} location={location} /> // location is used to get information of previous page when use Redirect of react-router-dom
  },
  {
    name: "ApllicationDetail",
    path: "/applications/:id",
    exact: true,
    main: ({ match, location }) => <PostDetail match={match} location={location} /> // location is used to get information of previous page when use Redirect of react-router-dom
  },
  {
    name: 'Products',
    path: '/products',
    exact: true,
    main: ({ match, location }) => <Posts match={match} location={location} />
  },
  {
    name: "ProductDetail",
    path: "/products/:id",
    exact: true,
    main: ({ match, location }) => <PostDetail match={match} location={location} /> // location is used to get information of previous page when use Redirect of react-router-dom
  },
  {
    name: "PromotionCode",
    path: "/promotion-codes",
    exact: true,
    type: 'menu',
    main: ({ match, location }) => <Posts match={match} location={location} />
  },
  {
    name: "PromotionCodeDetail",
    path: "/promotion-codes/:id",
    exact: true,
    main: ({ match, location }) => <PostDetail match={match} location={location} /> // location is used to get information of previous page when use Redirect of react-router-dom
  },
  {
    name: "Services",
    path: "/services",
    exact: true,
    main: ({ match, location }) => <Posts match={match} location={location} />
  },
  {
    name: 'SearchResult',
    path: '/search/:id',
    exact: true,
    main: ({ match, location }) => <Posts match={match} location={location} />
  },
  {
    name: 'Login',
    path: '/auth/login',
    exact: true,
    main: (match) => <Login match={match} />
  },
  {
    name: "Admin",
    path: "/admin/dashboard/:id",
    exact: true,
    isPrivate: true,
    main: () => <Admin />
  },
];

export { routes };
